const env = process.env.NODE_ENV === "production" ? "prod" : "dev";
const log = env === "dev";

export { env, log };
